// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

/**
 * `NodeJS.ReadableStream` is not available in React Native.
 *
 * @public
 */
export type NodeReadableStream = never;

/**
 * `Buffer` is not available in React Native.
 *
 * @public
 */
export type NodeBuffer = never;

/**
 * `ReadableStream` is not available in React Native.
 *
 * @public
 */
export type WebReadableStream<_R = any> = never;
